import { useQuery } from 'react-query';

import { getUserDetails as queryFn } from 'api/endPoints/getUserDetails';

export const useQueryGetUserDetail = (params: { email?: string }) => {
    return useQuery<IGetUserDetailResponse, QueryError>(['getUserDetail', params], () => queryFn(params), {
        enabled: Boolean(params.email),
    });
};

type IPrivilegesMap = {
    [K in keyof IPrivileges]: {
        [K2 in K]: IPrivilegesType;
    };
}[keyof IPrivileges];
export type TMfaType = 'off' | 'email' | 'google' | 'microsoft';

export interface IGetUserDetailResponse {
    badLoginAttempts: number;
    customerId: number;
    defaultProjectId: number;
    email: string;
    firstName: string;
    globalFilterStatus: {
        showFilterToggleButton: boolean;
        showActivityCodeFilter: boolean;
        isFilterExpanded: boolean;
    };
    homePageUrl: string;
    image: string;
    lastLogin: number;
    lastName: string;
    logo: string;
    phone: string;
    privilegeMap: IPrivilegesMap;
    roleList: IRole[];
    status: 'ACTIVE';
    title: string;
    userGroupList: string[];
    username: string;
    uuid: string;
    mfa: TMfaType;
    confetti: boolean;
}
